import styled from 'styled-components'

export const Container = styled.div`
    width: auto;
    max-width: 1000px;
    height: 100%;
    position: relative;
    overflow: hidden;
`
